import { IStackStyles, mergeStyles, Stack, Text } from "@fluentui/react";
import { FC, useEffect, useState } from "react";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { colorPallete } from "../../../assets/color";
import { Thumbnails } from "../../Thumbnails";
import EditIcon from "../../../assets/Icons/svg/editIcon";
import TrashIcon from "../../../assets/Icons/svg/trashIcon";
import OpenFile from "../../../navigation/NoobOrPro";
import { getSplitDocumentName } from "../../../utils";
import { getDocumentversions } from "../../../modules/redux/Documents/document";
import { useAppDispatch } from "../../../hooks/hooks";
import ImportIcon from "../../../assets/Icons/svg/ImportIcon";
import ShowDocumentHistoryIcon from "../../../assets/Icons/svg/showDocumentHistoryIcon";
import "./index.css";
import { useTranslation } from "react-i18next";

const styles = {
  ImageStyle: {
    borderTopLeftRadius: "0.4rem",
    borderTopRightRadius: "0.4rem",
  },
  FileNameStackStyle: {
    height: "20%",
    backgroundColor: "",
    width: "97%",
    paddingLeft: "10px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  container: {
    width: "100%",
    height: "72%",
    marginLeft: "3%",
    backgroundColor: "red",
    alignItems: "flex-start",
  },
  FileName: {
    fontSize: "16px",
    paddingLeft: "1%",
    color: colorPallete.black,
    lineHeight: "20px",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    maxWidth: "85%",
    backgroundColor: "",
    fontFamily: "Poppins",
  },
  EditIcon: {
    marginTop: "5%",
    bottom: 20,
    left: 12,
    justifyContent: "space-between",
  },
  DocCover: {
    height: "104px",
    aspectRatio: "9/5",
    background: colorPallete.btLightBlue,
    boxShadow: "0px 4px 6px rgb(0 0 0 / 25%)",
    zIndex: 1,
    padding: "4%",
    minWidth: "190px",
  },
  DocCard: {
    height: "300px",
    minWidth: "200px",
    boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, .25)",
    cursor: "pointer",
    aspectRatio: "21/29",
    flexShrink: 0,
  },
};

const stackStyles: IStackStyles = {
  root: {
    width: "100%",
    height: "100%",
    position: "absolute",
    opacity: 0.8,
  },
};

export const ProjectDocumentCard: FC<any> = (props) => {
  const {
    document,
    selectedId,
    onHistoryClick,
  } = props;
  const dispatch = useAppDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  return (
    <div
      style={{ ...styles.DocCard, position: "relative" }}
      title={props.document?.rootDocumentName ?? ""}
      key={props.document?.id}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onHistoryClick}
    >
      <VerticalStack styles={stackStyles}>
        <Thumbnails
          driveItemId={props.document.driveItemId}
          height={550}
        />
      </VerticalStack>
      <VerticalStack
        style={{ ...styles.DocCover, position: "absolute" }}
        title={props.document?.rootDocumentName ?? ""}
      >
        <HorizontalStack title={props.document?.rootDocumentName ?? ""}>
          <Text
            className={mergeStyles(styles.FileName)}
            style={{ WebkitLineClamp: 2, overflow: "hidden", fontWeight: 400 }}
          >
            {getSplitDocumentName(props.document?.rootDocumentName) ?? ""}
          </Text>
        </HorizontalStack>
        <HorizontalStack style={{ ...styles.EditIcon, position: "absolute" }}>
          {props.document.fileType !== "pdf" && ( //Todo
            <Stack
              className="icon-container"
              style={{ cursor: "pointer" }}
              onClick={async (e) => {
                e.stopPropagation();
                const result = await dispatch(
                  getDocumentversions({ rootDocumentId: props.document.rootDocumentId })
                ).unwrap();
                const latestVersion = result?.data?.[0];
                const link = latestVersion?.metadata?.documentLink;
                const webLink = latestVersion?.metadata?.documentWebLink || latestVersion?.documentWebLink;
                OpenFile(link, webLink);
              }}
            >
             <EditIcon />
            </Stack>
          )}

          <Stack
            className="icon-container"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              props.deleteDocName(
                getSplitDocumentName(props.document.rootDocumentName)
              );
              props.deleteRootDocId(props.document.rootDocumentId);
              props.showModal();
            }}
          >
            <TrashIcon />
          </Stack>
          <Stack
            className="icon-container"
            style={{
              cursor: "pointer",
              display:
                props.document?.rootDocumentId === props.selectedId
                  ? ""
                  : "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              props?.setRootDocumentId!(props.document?.rootDocumentId);
              props?.showImportModal!();
            }}
          >
            <ImportIcon />
          </Stack>
        </HorizontalStack>
      </VerticalStack>
      
      {(document.rootDocumentId === selectedId || isHovered) && (
        <div 
          className="documentHistoryContainer"
          style={{
            opacity: isHovered && document.rootDocumentId !== selectedId ? 0.9 : 1,
          }} 
        >
          <Text className="documentHistoryTag">{t("document_history")}</Text>
          <div className="documentHistoryArrow">
            <ShowDocumentHistoryIcon />
          </div>
        </div>
      )}
    </div>
  );
};
